// frontend/src/components/landing/landingTheme.js
import { createTheme } from '@mui/material/styles';
import { brand } from '../../tokens';

// Soft and airy, academic with a bit of play: white page, deep navy accent, peach as the supporting
// tone; one soft glow behind the hero and the closing band, floating CDAT code chips in the hero.
// Colours and fonts come from the shared brand tokens; the display scale is the landing page's own.
export const tokens = {
    ...brand,
    surface: brand.paper,
    shadow: '0 1px 2px rgba(11, 18, 32, 0.04), 0 12px 32px -12px rgba(30, 58, 95, 0.12), 0 32px 64px -32px rgba(30, 58, 95, 0.14)',
    shadowLift: '0 2px 4px rgba(11, 18, 32, 0.05), 0 20px 40px -16px rgba(30, 58, 95, 0.20), 0 48px 80px -40px rgba(30, 58, 95, 0.22)',
};

// Fractal noise as a tiling SVG, for a light grain over the focal points
export const GRAIN = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

const base = createTheme({
    palette: {
        primary: { main: tokens.accent, contrastText: '#FFFFFF' },
        secondary: { main: tokens.highlight, contrastText: tokens.ink },
        text: { primary: tokens.ink, secondary: tokens.inkMuted },
        background: { default: tokens.paper, paper: tokens.surface },
        divider: tokens.line,
    },
    typography: {
        fontFamily: tokens.body,
    },
});

// Type scale: display (h1), section (h2), card (h3), lead (subtitle1), body (body1), small (body2), label (overline)
const landingTheme = createTheme(base, {
    typography: {
        h1: {
            fontFamily: tokens.display,
            fontWeight: 800,
            fontSize: '2.75rem',
            lineHeight: 1.0,
            letterSpacing: '-0.045em',
            [base.breakpoints.up('sm')]: { fontSize: '4rem' },
            [base.breakpoints.up('md')]: { fontSize: '5.25rem' },
            [base.breakpoints.up('lg')]: { fontSize: '6rem' },
        },
        h2: {
            fontFamily: tokens.display,
            fontWeight: 700,
            fontSize: '2.125rem',
            lineHeight: 1.08,
            letterSpacing: '-0.035em',
            [base.breakpoints.up('md')]: { fontSize: '3.25rem' },
        },
        h3: {
            fontFamily: tokens.display,
            fontWeight: 700,
            fontSize: '1.375rem',
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
        },
        subtitle1: {
            fontSize: '1.125rem',
            lineHeight: 1.6,
            color: tokens.inkMuted,
            [base.breakpoints.up('md')]: { fontSize: '1.25rem' },
        },
        body1: { fontSize: '1rem', lineHeight: 1.65 },
        body2: { fontSize: '0.875rem', lineHeight: 1.55 },
        overline: {
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '0.1em',
            lineHeight: 1.4,
        },
    },
});

export default landingTheme;
